import { Icon } from '@iconify/react'
import { useTheme } from 'next-themes'

import { IconButton } from '~in-app/components/IconButton'

export const ThemeButton = () => {
  const { resolvedTheme, setTheme } = useTheme()

  const toggleTheme = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')
  }

  return (
    <IconButton
      className="bg-transparent hover:opacity-100"
      color="muted"
      shape="circle"
      size="small"
      onClick={toggleTheme}
    >
      {
        resolvedTheme === 'dark'
          ? (
              <Icon
                icon="lucide:moon"
              />
            )
          : (
              <Icon
                icon="lucide:sun"
              />
            )
      }
    </IconButton>
  )
}
